<template>
  <v-row justify="center" align="center">
    <v-col>
      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-left="0"
        :nudge-bottom="5"
        transition="scale-transition"
        offset-y
        width="303"
      >
        <template v-slot:activator="{ on }">
          <div v-on="on" :data-test-id="`${dataTestId}__start-date-range-picker__input-box-wrapper`">
            <v-text-field
              solo
              flat
              filled
              v-model="visibleSelectedDateStart"
              class="pointerCursor"
              append-icon="expand_more"
              readonly
              height="52px"
              background-color="#E5E5E5 !important"
            ></v-text-field>
          </div>
        </template>
        <v-date-picker
          v-model="dateStart"
          :max="getMaxDate"
          min="2013-01-01"
          @input="handleDateChangeRequeststart"
          @change="menu2 = false"
          no-title
          :color="DATEPICKER_COLOR"
          class="datepickerPanel"
          :data-test-id="`${dataTestId}__start-date-picker`"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <v-col col="1">
      <p class="andText text-center">and</p>
    </v-col>
    <v-col>
      <v-menu
        v-model="menu1"
        :close-on-content-click="false"
        :nudge-left="0"
        :nudge-bottom="5"
        transition="scale-transition"
        offset-y
        width="303"
      >
        <template v-slot:activator="{ on }">
          <div v-on="on" :data-test-id="`${dataTestId}__end-date-range-picker__input-box-wrapper`">
            <v-text-field
              solo
              flat
              v-model="visibleSelectedDateEnd"
              filled
              class="pointerCursor"
              append-icon="expand_more"
              readonly
              height="52px"
              background-color="#E5E5E5 !important"
            ></v-text-field>
          </div>
        </template>
        <v-date-picker
          v-model="dateEnd"
          :max="getMaxDate"
          min="2013-01-01"
          @input="handleDateChangeRequestend"
          @change="menu1 = false"
          no-title
          :color="DATEPICKER_COLOR"
          class="datepickerPanel"
          :data-test-id="`${dataTestId}__end-date-picker`"
        ></v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>
<script>
import EventBus from '@/EventBus';
import colors from '@/constants/colors';
export default {
  props: {
    dataTestId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      DATEPICKER_COLOR: colors.chartPrimary,
      dateRawFormat: null,
      menu1: false,
      menu2: false,
      dateStart: new Date().toISOString().substr(0, 10),
      dateEnd: new Date().toISOString().substr(0, 10),
      maxDate: new Date().toISOString().substr(0, 10)
    };
  },
  mounted() {
    EventBus.$on('SET_EDIT_PROJECT_DATES', (startDate, endDate) => {
      this.dateStart = startDate;
      this.dateEnd = endDate;
    });
  },
  methods: {
    handleDateChangeRequeststart() {
      const dateStart = new Date(this.dateStart).toISOString().substr(0, 10);
      const dateEnd = new Date(this.dateEnd).toISOString().substr(0, 10);
      if (dateStart < dateEnd) {
        EventBus.$emit('GET_STARTRANGE_DATE', dateStart);
      } else {
        EventBus.$emit('GET_STARTRANGE_DATE', false);
        this.snackbar('error', this.$message.DATE_RANGE_START);
      }
    },
    handleDateChangeRequestend() {
      const dateEnd = new Date(this.dateEnd).toISOString().substr(0, 10);
      const dateStart = new Date(this.dateStart).toISOString().substr(0, 10);
      if (dateStart < dateEnd) {
        EventBus.$emit('GET_ENDRANGE_DATE', dateEnd);
      } else {
        EventBus.$emit('GET_ENDRANGE_DATE', false);
        EventBus.$emit('GET_ENDRANGE_DATE', dateEnd);
        this.snackbar('error', this.$message.DATE_RANGE_END);
      }
    }
  },
  computed: {
    visibleSelectedDateStart() {
      return this.dateStart
        ? this.getFormattedDate({
            date: this.dateStart,
            timeZone: 'utc',
            format: 'DD/MM/YYYY'
          })
        : '';
    },
    visibleSelectedDateEnd() {
      return this.dateEnd
        ? this.getFormattedDate({
            date: this.dateEnd,
            timeZone: 'utc',
            format: 'DD/MM/YYYY'
          })
        : '';
    },
    getMaxDate: {
      get() {
        return this.maxDate
          ? this.getFormattedDate({
            date: this.maxDate,
            timeZone: 'utc'
          })
          : '';
      },
      set(date) {
        this.maxDate = date;
      }
    }
  },
  beforeDestroy() {
    EventBus.$off('SET_EDIT_PROJECT_DATES');
  }
};
</script>

<style scoped>
.showDate {
  height: 52px;
  width: 220px;
  background: #e5e5e5;
  padding: 14px;
  text-align: center;
  color: #1b2342;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
}

.andText {
  margin: 0 29px;
}
</style>
